<template>
  <div>
    <UserBalance></UserBalance>
    <FuturesOrder></FuturesOrder>
    <UserPosition></UserPosition>
  </div>
</template>

<script>
import { getCurrentInstance, onMounted, onUnmounted, reactive, ref } from 'vue'
import { useStore } from 'vuex'
import UserBalance from '../components/UserBalance.vue'
import FuturesOrder from '../components/FuturesOrder.vue'
import UserPosition from '../components/UserPosition.vue'
export default {
  components: { UserBalance, FuturesOrder, UserPosition },
  setup () {
    const vueEvent = getCurrentInstance()?.appContext.config.globalProperties.vueEvent
    const store = useStore()
    const obj = reactive({

    })

    // 生命周期函数 挂载完毕事件
    onMounted(() => {
      vueEvent.emit('navbarMenuIdxEvent', '1-2') 
      vueEvent.emit('sidebarMenuIdxEvent', '')
      renderView()
    })

    // 生命周期函数 挂载销毁事件
    onUnmounted(() => {
      
    })

    // 渲染画面
    const renderView = () => {
      requestData()
    }

    // 后台获取数据
    const requestData = () => {
      processData()
    }
    
    // 加工处理数据
    const processData = (res) => {
    }

    return {
      obj,
      store
    }
  }
}
</script>
